import {showMessage} from 'exsportia-components'

import {getPromoErrorFromResponse} from '../../api/promo-codes/helpers'
import {queryClient} from '../../utils/react-query'
import {getPromoErrorMessage} from './use-promo-text'

type SetFieldValue = (field: string, value: unknown) => unknown

// Pay-time promo errors (contract §4): 409 PROMO_PRICE_CHANGED → re-quote and ask to pay again;
// 422 with a §2 code → show it and take the code off the booking. Returns true when handled.
export const handlePromoPayError = (
  error: unknown,
  setFieldValue: SetFieldValue,
  quoteQueryKey: string,
): boolean => {
  const promoError = getPromoErrorFromResponse(error)
  if (!promoError) {
    return false
  }
  if (promoError.code === 'PROMO_PRICE_CHANGED') {
    void queryClient.refetchQueries([quoteQueryKey])
  } else {
    void setFieldValue('promoCode', null)
    void setFieldValue('promoRejection', promoError)
  }
  showMessage(getPromoErrorMessage(promoError), 'error')
  return true
}

export const isPromoPayError = (error: unknown) => Boolean(getPromoErrorFromResponse(error))
